import { useLazyQuery } from '@apollo/client';
import { useMemo } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  ALL_ITEMS
} from '@/config/common.config';
import { notificationService } from '@/services/notification/notification.client';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import {
  GetPaginatedFilteredBCContractLines,
  GetPaginatedFilteredBCContractLinesVariables
} from '@/graphql/contracts/_generated_/getPaginatedFilteredBCContractLines.query';
import { ContractLineFilterInput } from '@/graphql/contracts/_generated_/contracts';

export default function useGetPaginatedBCContractLines() {
  const [_getPaginatedBCContractLines, { loading, error, data }] =
    useLazyQuery<GetPaginatedFilteredBCContractLines, GetPaginatedFilteredBCContractLinesVariables>(
      GetBCContractLinesQuery, {
        client: apolloClientContracts,
        fetchPolicy: 'network-only',
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      });

  const getPaginatedBCContractLines = (dto: ContractLineFilterInput) => {
    _getPaginatedBCContractLines({
      variables: {
        filter: dto,
        first: ALL_ITEMS
      }
    });
  };

  return useMemo(() => ({
    getPaginatedBCContractLines,
    isLoadingPaginatedBCContractLines: loading,
    errorPaginatedBCContractLines: error,
    // eslint-disable-next-line max-len
    paginatedBCContractLines: data?.paginatedFilteredContractLinesByBillingCycles?.items ?? []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [loading, error, data]);
}
